import { render, staticRenderFns } from "./time_sale_setting_add.vue?vue&type=template&id=2e655775&"
import script from "./time_sale_setting_add.vue?vue&type=script&lang=ts&"
export * from "./time_sale_setting_add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports